import script from "./KeywordEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./KeywordEdit.vue?vue&type=script&setup=true&lang=js"

import "./KeywordEdit.vue?vue&type=style&index=0&id=182bc5c8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-182bc5c8"]])

export default __exports__